/**
 * Carrega o dataset de garantia/RMA uma vez por tela e separa carregando /
 * erro / dado (Task 15). Mesmo papel do `FulfillmentBoundary`: nenhuma tela de
 * RMA repete essa lógica nem confunde erro de carga com "nenhum caso".
 *
 * Migrado para `.tsx`/JSX real (Cluster D — Logística & Garantias, redesign
 * por perfil; ver `docs/architecture/ADR-0011-*.md`). Mudança de sintaxe
 * apenas (`createElement` → JSX) — nenhum ícone foi adicionado aqui, pela
 * mesma razão do `FulfillmentBoundary.tsx` (delega para `StatusPanel`, que já
 * tem ícone por `kind`).
 */
// Import explícito de `React` — ver o mesmo comentário em `FulfillmentBoundary.tsx`.
import React, { type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useRmaDataset } from "../queries.js";
import type { RmaDataset } from "../rma/dataset.js";

export interface RmaBoundaryProps {
  children: (dataset: RmaDataset) => ReactElement;
}

export function RmaBoundary({ children }: RmaBoundaryProps): ReactElement {
  const query = useRmaDataset();
  if (query.isPending) {
    return <StatusPanel kind="loading" title="Carregando os casos de garantia…" />;
  }
  if (query.error) {
    return <StatusPanel kind="error" title="Não foi possível carregar as garantias" detail={errorDetail(query.error)} />;
  }
  if (!query.data) {
    return <StatusPanel kind="empty" title="Nenhum dado de garantia retornado pela API da Plataforma" />;
  }
  return children(query.data);
}
